export default __webpack_public_path__ + "static/media/phylactere_etudierL.98e2e184.png";